import script from "./AdminHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHeader.vue?vue&type=script&setup=true&lang=js"

import "./AdminHeader.vue?vue&type=style&index=0&id=7e0674dc&lang=css"

const __exports__ = script;

export default __exports__